export const universities = [
  {
    value: 'UABC',
    label: 'UABC',
    children: [
      {
        value: 'OTAY',
        label: 'OTAY'
      },
      {
        value: 'VALLE DE LAS PALMAS',
        label: 'VALLE DE LAS PALMAS'
      },
      {
        value: 'MEXICALI',
        label: 'MEXICALI'
      },
      {
        value: 'ENSENADA',
        label: 'ENSENADA'
      }
    ]
  },
  {
    value: 'ITT',
    label: 'ITT',
    children: [
      {
        value: 'OTAY',
        label: 'OTAY'
      },
      {
        value: 'TOMAS AQUINO',
        label: 'TOMAS AQUINO'
      }
    ]
  }
];

export const studies = [
  {
    value: 'INGENIERÍA',
    label: 'Ingeniería',
    children: [
      {
        value: 'TRONCO COMÚN',
        label: 'Tronco Común'
      },
      {
        value: 'SISTEMAS COMPUTACIONALES',
        label: 'Sistemas Computacionales'
      },
      {
        value: 'COMPUTACIÓN',
        label: 'Computación'
      },
      {
        value: 'ELECTRÓNICA',
        label: 'Electrónica'
      },
      {
        value: 'QUÍMICA',
        label: 'Química'
      },
      {
        value: 'MECATRÓNICA',
        label: 'Mecatrónica'
      },
      {
        value: 'INDUSTRIAL',
        label: 'Industrial'
      }
    ]
  }
];
